
import {Component, Mixins} from 'vue-property-decorator';
import {deleteMessage, getMessages} from '@pazion/pazion-core/src/services/auth-service';
import PazRefreshButton from "@pazion/pazion-core/src/components/controls/PazRefreshButton.vue";
import DataDialog from "@pazion/pazion-core/src/components/utils/DataDialog.vue";
import PazTextSearch from "@pazion/pazion-core/src/components/controls/PazTextSearch.vue";
import PazListFilterSelector from "@pazion/pazion-core/src/components/utils/PazListFilterSelector.vue";
import PazTooltipButton from "@pazion/pazion-core/src/components/controls/PazTooltipButton.vue";
import PazConfirmation from "@pazion/pazion-core/src/components/utils/PazConfirmation.vue";
import PazTooltipText from "@pazion/pazion-core/src/components/controls/PazTooltipText.vue";
import EntityLogMixin from "@pazion/pazion-core/src/mixins/EntityLog.mixin";
import EntityLogDialog from "@pazion/pazion-core/src/components/utils/EntityLogDialog.vue";

@Component({
  components: {
    PazTooltipText,
    DataDialog,
    PazRefreshButton,
    PazTextSearch,
    PazListFilterSelector,
    PazTooltipButton,
    PazConfirmation,
    EntityLogDialog
  }
})
export default class MessagePage extends Mixins(EntityLogMixin) {

  public extraInfo = {};
  public dialog = false;
  public loading: boolean = false;
  public search: string = '';
  public items = [];
  public headers: object[] = [
    {
      text: 'id',
      align: 'right',
      sortable: true,
      value: 'id',
      class: 'nowrap',
      cellClass: 'nowrap',
    },
    {
      class: 'nowrap',
      cellClass: 'nowrap',
      text: 'Date',
      align: 'right',
      sortable: true,
      value: 'createdAt',
    },
    {
      text: 'Subject',
      align: 'left',
      sortable: true,
      value: 'subject',
    },
    {
      class: 'nowrap',
      text: 'Type',
      align: 'center',
      sortable: true,
      value: 'type',
    },
    {
      class: 'nowrap',
      text: 'Direction',
      align: 'center',
      sortable: true,
      value: 'direction',
    },
    {
      text: 'To',
      align: 'left',
      sortable: true,
      value: 'to',
    },
    {
      text: 'Status',
      align: 'left',
      sortable: true,
      value: 'status',
    },
    {
      class: 'nowrap',
      text: 'extra info',
      align: 'right',
      sortable: true,
      value: 'action',
    },
  ];

  get filteredItems() {
    return this.items;
  }


  created() {
  }

  mounted() {
    this.fetchData();

  }

  async fetchData() {
    this.loading = true;
    this.items = await getMessages();
    this.loading = false;
  }

  showInfo(item: any) {
    this.extraInfo = item;
    if (item.json != null) {
      this.extraInfo.json = JSON.parse(item.json);
    }
    if (item.headers && item.headers.includes("\r\n")) {
      this.extraInfo.headers = item.headers.split("\r\n");
    }
    this.dialog = true;
  }

  async deleteMessages(item: any) {
    const confirm = await this.$refs.confirmDeleteMessage.openConfirmDialog(
        "Delete",
        `Do you want to delete Message ${item.subject}?`
    );
    if (confirm) {
      const rsp = await deleteMessage(item.id);
      if (rsp.id > 0) {
        await this.fetchData();
      }
    }
  }
}
